import React from 'react';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';
import ReferenceEnterCustomReasonFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Reference/ReferenceEnterCustomReasonFP';

//= ========================================================================

const Sim_J02_LoanNumberInstallments = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { number } = globJSON.configurations.services[subCategoryId];

  return (
    <ReferenceEnterCustomReasonFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      subCategoryId={subCategoryId}
      inputText={number.enter_number_installments}
      headlineText={number.enter_number_installments}
      slideshowRefs={slideshowRefs}
      withOutKeyboard
      isLoan
    />
  );
};

export default Sim_J02_LoanNumberInstallments;
